import { gql } from "apollo-boost";

export const GET_ALL_FACILITIES = gql`
  query {
    allFacility {
      edges {
        node {
          facilityId
          name
          desc
          contactInfo
          urlToDetails

          type
          address
          city
          countryId
          latitude
          longitude
          tag
          userId
          updateSource
          updateDate
        }
      }
    }
  }
`;
